module.exports = __webpack_public_path__ + "static/media/other-reports-icon.dee2fc4a.svg";